// extracted by mini-css-extract-plugin
export var button = "_10-1";
export var featuredLink = "_10-4";
export var spinner = "_10-2";
export var spinnerContainer = "_10-3";
export var text = "_10-0";